import { Vue, Component } from "vue-property-decorator";
import { Getter, State } from "vuex-class";
import { AreaEventHistoryColumnKey } from "@/types/sv-data/AreaEventHistory";
import { TableHeader } from "@/components/table/generic-table.vue";
import { TenantSystemPrefs } from "@/store/types";
import { buildAvailableColumns, parseEventAreaHistoryColumnPrefs } from "@/utils/areaEventHistoryUtils";

@Component({})
export default class AreaEventHistoryColumnsMixin extends Vue {
    @Getter("getFeature") public getFeature: (featureName: string[]) => boolean;
    @State("tenantSystemPrefs") public tenantSystemPrefs: TenantSystemPrefs;
	@Getter("getAreaEventHistoryDefaultColumnsConfiguration") private areaEventHistoryDefaultColumnsConfiguration: string | null;

    private get configureColumnsEnabled(): boolean {
        return this.getFeature(["Areas", "AreaEventHistory", "ColumnConfiguration", "ColumnVisibility"]);
    }

    protected get columnDescriptions(): Record<AreaEventHistoryColumnKey, string> {
        return {} as Record<AreaEventHistoryColumnKey, string>;
    }

    protected mergeDefaultWithPrefConfiguredColumns(defaultColumns: TableHeader[], prefConfigurationValue: string): TableHeader[] {
        const parsedPrefs = parseEventAreaHistoryColumnPrefs(prefConfigurationValue);
        if (!parsedPrefs.length) {
            return defaultColumns;
        }

        const prefMap = new Map(parsedPrefs.map(pref => [pref.key, pref]));

        return defaultColumns.map(col => {
            const pref = prefMap.get(col.key as AreaEventHistoryColumnKey);
            if (pref !== undefined) {
                return { ...col, visible: pref.visible };
            }
            return col;
        });
    }

    public get defaultColumns(): TableHeader[] {
        const columns = buildAvailableColumns(this.getFeature);

        const descriptions = this.columnDescriptions;
        if (Object.keys(descriptions).length === 0) {
            return columns;
        }

        return columns.map(col => {
            const description = descriptions[col.key as AreaEventHistoryColumnKey];
            if (description !== undefined) {
                return { ...col, description };
            }
            return col;
        });
    }

	public get columns(): TableHeader[] {
        if (!this.configureColumnsEnabled) {
            return this.defaultColumns;
        }

		return this.mergeDefaultWithPrefConfiguredColumns(this.defaultColumns, this.areaEventHistoryDefaultColumnsConfiguration);
	}
}
